function numbersOnly(str) {
  return str.replace(/\D/g, '')
}

module.exports = numbersOnly
